import React, {Fragment} from 'react';
import WithDrawalContent from '../../components/account/WithDrawalContent';

const WithDrawal = () => {
    
    return (
        <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">환전신청</div>
                </div>
            </div>
            <WithDrawalContent></WithDrawalContent>    
        
        </Fragment>
    );
};

export default WithDrawal;


// WEBPACK FOOTER //
// ./src/containers/Account/Withdrawal.js